import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import moment from 'moment';
import { PriceListService } from '../../shared/price-list.service';
import { ActivatedRoute } from '@angular/router';
import { PriceList } from 'src/app/shared/models/PriceList';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { Title } from '@angular/platform-browser';
import { EventsService } from 'src/app/events/shared/events.service';

@Component({
    selector: 'app-price-list-summery-paper',
    templateUrl: './price-list-summery-paper.component.html',
    styleUrls: ['./price-list-summery-paper.component.scss'],
    standalone: false
})
export class PriceListSummeryPaperComponent implements OnInit {

  public today = moment();
  public priceList: PriceList = new PriceList();

  public eventCurrency = '€';

  @ViewChild('container', { static: true })
  container: ElementRef;

  constructor(private _priceListService: PriceListService, private _route: ActivatedRoute, private titleService: Title, private _eventService: EventsService) { }

  ngOnInit() {
    this._route.params.subscribe(params => {
      this._priceListService.gatPriceListsById(params['priceListId']).subscribe(result => {
        this.priceList = result;
        this.titleService.setTitle("[" + this.priceList.id + "] Pricelist Summary - FAdminFrontend");

        this._eventService.getEventById(this.priceList.event.id + "").subscribe(res => {
          this.eventCurrency = res.deviceUsers[0].currency;
        });

      });
    });
  }

  printPriceListLayout() {
    window.print();
  }

  downloadPdfPriceListLayout() {
    html2canvas(this.container.nativeElement).then(canvas => {
      const pdf =  new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: [canvas.width, canvas.height]
      });
      const imgData = canvas.toDataURL('image/jpeg', 1.0);
      pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
      pdf.save(this.priceList.name + '.pdf');
    });
  }
}
